<script setup lang="ts">
import { pluralize, download, neirogenerations } from '~/utils/TextHelper'

interface Props {
  nameRate: string
  costByMonth: number
  downloads?: number
  generations?: number
  descriptionBottom?: string
  generationBottom?: string
  folderManagement?: boolean
  generationStorage?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  downloads: undefined,
  generations: undefined,
  descriptionBottom: '',
  generationBottom: '',
  folderManagement: false,
  generationStorage: false,
})

const downloadText = computed(() => {
  return props.downloads ?
    pluralize(props.downloads, download) + ' в месяц' :
    'Безлимит скачиваний'
})

const generationsText = computed(() => {
  return props.generations ?
    pluralize(props.generations, neirogenerations) + ' в месяц' :
    'Безлимит нейрогенераций'
})

</script>

<template>
  <div class="rate-item-wrap">
    <div class="rate-item">
      <div
        v-if="nameRate"
        class="rate-item__name"
      >
        {{ nameRate }}
      </div>
      <div class="rate-item__info">
        <div class="rate-item__title">
          {{ costByMonth }}<span class="title-cost">₽/месяц</span>
        </div>
        <div class="rate-item__body">
          <div>•&nbsp;{{ generationsText }}</div>
          <div>•&nbsp;{{ downloadText }}</div>
          <div v-if="generationStorage">
            •&nbsp;Хранение нейрогенераций
          </div>
          <div v-if="folderManagement">
            •&nbsp;Управление папками
          </div>
        </div>
      </div>
      <slot name="button" />
    </div>
    <slot name="description" />
    <div
      v-if="descriptionBottom || generationBottom"
      class="mt-2"
    >
      <div>{{ descriptionBottom }}</div>
      <div>{{ generationBottom }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.rate-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid $gray-300;
  min-height: rem(248px);
  position: relative;
  margin-bottom: rem(8px);
  height: 100%;

  &__name {
    background: $white;
    border: 1px solid $gray-300;
    border-radius: rem(4px);
    padding: rem(3px) rem(12px);
    position: absolute;
    top: rem(-16px);
    left: rem(16px);
  }

  &__info {
    position: relative;
    padding: rem(28px) rem(15px) rem(28px);
    min-height: rem(205px);
  }

  &__title {
    font-family: 'Montserrat', sans-serif;
    font-size: rem(38px);
    font-weight: bold;
    line-height: 1.2;

    @include media-breakpoint-down(md) {
      font-size: rem(28px);
    }

    .title-cost {
      font-family: 'Roboto', sans-serif;
      font-size: rem(16px);
      line-height: 1.5;
      font-weight: 400;
      margin-left: rem(4px);
    }
  }

  &__body {
    font-size: rem(16px);
    line-height: 1.5;
    margin: rem(4px) 0 0;
  }
}
</style>
